var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161228",
    "data-name": "Group 161228",
    transform: "translate(-206 -51.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-big-arrow",
    transform: "translate(212.986 51.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30580",
    "data-name": "Rectangle 30580",
    width: 64,
    height: 64,
    transform: "translate(-6.986 0.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-microsoftexcel",
    "data-name": "Icon simple-microsoftexcel",
    d: "M43.651,5.672H28.75V8.429h4.392v4.363H28.75v1.39h4.392V18.55H28.75v1.429h4.392V24.11H28.75v1.655h4.392v4.14H28.75V31.56h4.392v4.164H28.75v3.038h14.9c.235-.07.432-.348.589-.83a4.064,4.064,0,0,0,.239-1.179V6.176c0-.237-.082-.38-.239-.43A2.039,2.039,0,0,0,43.651,5.672ZM41.718,35.721H34.57V31.56h7.148v4.161Zm0-5.816H34.57V25.763h7.148Zm0-5.8H34.57V20h7.148v4.112Zm0-5.56H34.57V14.186h7.148v4.363Zm0-5.78H34.57V8.431h7.148v4.337ZM0,4.984V39.457L26.243,44V.329L0,5ZM15.555,31.062q-.15-.406-1.4-3.453c-.832-2.031-1.334-3.214-1.481-3.551h-.046l-2.815,6.7L6.045,30.5l4.463-8.34-4.087-8.34,3.836-.2,2.535,6.525h.05l2.863-6.822,3.964-.25L14.951,22.1l4.865,9.207-4.261-.25Z",
    transform: "translate(2.774 11.992)",
    fill: "#387a47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.790cc9e0b17e99bd7d18767d15d55d6f.svg";
export { ForwardRef as ReactComponent };